import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const AutomatedBorderControlIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M16.9 11C16.6685 9.87136 16.0545 8.85723 15.1617 8.12898C14.2689 7.40072 13.1521 7.00299 12 7.00299C10.8479 7.00299 9.73105 7.40072 8.83827 8.12898C7.94549 8.85723 7.33148 9.87136 7.1 11H1V5H23V11H16.9ZM7.1 13C7.33148 14.1286 7.94549 15.1428 8.83827 15.871C9.73105 16.5993 10.8479 16.997 12 16.997C13.1521 16.997 14.2689 16.5993 15.1617 15.871C16.0545 15.1428 16.6685 14.1286 16.9 13H23V19H1V13H7.1ZM12 15C11.2044 15 10.4413 14.6839 9.87868 14.1213C9.31607 13.5587 9 12.7956 9 12C9 11.2044 9.31607 10.4413 9.87868 9.87868C10.4413 9.31607 11.2044 9 12 9C12.7956 9 13.5587 9.31607 14.1213 9.87868C14.6839 10.4413 15 11.2044 15 12C15 12.7956 14.6839 13.5587 14.1213 14.1213C13.5587 14.6839 12.7956 15 12 15Z'
                fill='currentColor'
            />
        </>
    ),
})

AutomatedBorderControlIcon.displayName = 'AutomatedBorderControlIcon'
